<template>
	<LayoutTableCommonRow>
		<LayoutTableCommonPartText :text="group.name" :header="dateFormatted" :subtext="(group.customers_count == 1) ? `1 Cliente` : `${group.customers_count} clientes`" />
		<LayoutTableCommonPartMenu>
			<template #options>
				<router-link :to="{ name: 'company.admin.group.form', params: { id: group.id }}" class="dropdown-item rounded-0">Editar</router-link>
				<a href="javascript:void(0)" class="dropdown-item rounded-0" @click="remove">Eliminar</a>
			</template>
		</LayoutTableCommonPartMenu>
	</LayoutTableCommonRow>
</template>

<script>
	import { computed } from 'vue';
	import _ from 'lodash';
	import moment from 'moment';

	export default {
		emits: ['remove'],
		props: {
			group: Object
		},
		setup(props, { emit }) {
			const dateFormatted = computed(() => moment(props.group.created_at).format('DD/MM/YYYY'));
			const remove = () => emit('remove', props.group);

			return { dateFormatted, remove };
		}
	}
</script>